import request from "@/utils/request";
import qs from "qs";

/**
 * 查询下级等级列表
 * @param params
 * @returns {*}
 */


export function getLowerLevelDtoList(data) {
  return request({
    url: "/agentOrder/getLowerLevelDtoList",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json"
    }
  });
}

export function addWithdrawAccount(data) {
  return request({
    url: "/agentWithdraw/addWithdrawAccount",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json"
    }
  });
}

export function queryWithdrawAccount(params) {
  return request({
    url: "/agentWithdraw/queryWithdrawAccount",
    method: "get",
    params
  });
}
export function deleteWithdrawAccount(params) {
  return request({
    url: "/agentWithdraw/deleteWithdrawAccount",
    method: "get",
    params
  });
}

// 获取银行列表
export function getBankListQuery() {
  return request({
    url: "/agentWithdraw/getBankList",
    method: "get"
  });
}

export function setAgentLogin(params) {
  return request.post("/agentAuth/setAgentLogin", qs.stringify(params));
}


